import getAllInventory from './getAllInventory';
import shuffleArray from '@helpers/shuffleArray';

export default async function (options = {}) {
  const query = {
    completeQty: options.completeQty || false,
    qty: options.qty || 10
  };

  try {
    const products = await getAllInventory();
    let featuredProduct = products.filter((a) => a.isFeaturedProduct === true);
    featuredProduct = shuffleArray(featuredProduct || [])

    if (query.completeQty) {
      shuffleArray(products || []).forEach((a) => {
        if (featuredProduct.length === query.qty) {
          return
        }

        if (
          !featuredProduct.find(
            (b) => b.domain === a.domain || b.lotteryID === a.lotteryID
          )
        ) {
          featuredProduct.push(a)
        }
      })
    }

    return featuredProduct;
  } catch (err) {
    console.error(err);
    return new Error(err);
  }
}
